import React from "react";
import { useDispatch } from "react-redux";
/*import {
  configurationCleanSearchText,
  configurationSetSearchText,
  cleanSearchingConfigurationsPaginated,
  startSearchingConfigurationPaginated,
} from "../../app/actions/configurationActions";*/

import { useTracking } from "react-tracking";
import { useTranslation } from "react-i18next";
import { catalogInstitutionCleanSearchText, catalogInstitutionSetSearchText, cleanSearchingCatalogInstitutionsPaginated, startSearchingCatalogInstitutionsPaginated } from "../../app/actions/catalogInstitutionActions";

const SearchBackCatalogInstitution = ({ searchText, setSearchText, itemsPerPage, setIsDisabledSearchText, isDisabledSearchText, setIsDisabledFilter, isDisabledFilter }) => {
 //console.log("SearchBackCatalogInstitution");
  
  const dispatch = useDispatch();
  const { trackEvent } = useTracking();
  const { t } = useTranslation();

  const onChangeInput = (event) => {
    setSearchText(event.target.value);

    if (event.target.value !== "") {
      setIsDisabledFilter(true);
      setIsDisabledSearchText(false);

      trackEvent({ component: "SearchCatalogInstitutions", event: "SearchCatalogInstitutions-Clicked", search: event.target.value });

      dispatch(catalogInstitutionSetSearchText(event.target.value));

      dispatch(startSearchingCatalogInstitutionsPaginated(event.target.value, 0, itemsPerPage));
    } else {
      setIsDisabledFilter(false);
      setIsDisabledSearchText(false);
      
      dispatch(cleanSearchingCatalogInstitutionsPaginated());

      dispatch(catalogInstitutionCleanSearchText());
    }
  };

  return (
    <div className="row height d-flex justify-content-center align-items-center">
      <div className="col-md-8">
        <div className="search">
          <i className="fa fa-search"></i>
          <input
            type="text"
            className="form-control"
            placeholder={t("general.option_search")}
            value={searchText}
            id="searchText"
            name="searchText"
            onChange={onChangeInput}
            disabled={isDisabledSearchText}
          ></input>
        </div>
      </div>
    </div>
  );
};

export default SearchBackCatalogInstitution;
